import {combineReducers} from 'redux';

import {LANDLORD_REQUEST, LANDLORD_SUCCESS, LANDLORD_FAILURE} from '../actions';
import {LANDLORD_UPDATE_REQUEST, LANDLORD_UPDATE_SUCCESS, LANDLORD_UPDATE_FAILURE} from '../actions';
import {DOCUMENT_UPLOAD_REQUEST, DOCUMENT_UPLOAD_SUCCESS, DOCUMENT_UPLOAD_FAILURE} from '../actions';
import {DOCUMENT_DELETE_REQUEST, DOCUMENT_DELETE_SUCCESS, DOCUMENT_DELETE_FAILURE} from '../actions';

import branchesReducer from './branches';
import adminsReducer from './admins';
import dloReducer from './dlo';
import contractorsReducer from './contractors';
import propertiesReducer from './properties';
import contractorSettings from './contractor-settings';

export const LANDLORD_INITIAL_STATE = {
    id: null,
    isFetching: false,
    error: null,
    business_name: '',
    address_line_1: '',
    address_line_2: '',
    address_line_3: '',
    post_code: '',
    contact_name: '',
    phone_number: '',
    contact_email: '',
    logo: null,
    documents: []
};

const landlordReducers = {
    [LANDLORD_REQUEST]: (state, {id}) => {
        return {...state, id, isFetching: true, error: null};
    },
    [LANDLORD_SUCCESS]: (state, {res}) => {
        return {...state, ...res.data, isFetching: false, error: null};
    },
    [LANDLORD_FAILURE]: (state, {error}) => {
        return {...state, isFetching: false, error};
    },
    [LANDLORD_UPDATE_REQUEST]: (state, action) => {
        return {...state, isFetching: true, error: null};
    },
    [LANDLORD_UPDATE_SUCCESS]: (state, {res}) => {
        return {...state, ...res.data, isFetching: false, error: null}
    },
    [LANDLORD_UPDATE_FAILURE]: (state, {error}) => {
        return {...state, isFetching: false, error}
    },
    [DOCUMENT_UPLOAD_REQUEST]: (state, action) => {
        return {...state, isFetching: true, error: null};
    },
    [DOCUMENT_UPLOAD_SUCCESS]: (state, {res}) => {
        return {...state, ...res.data, isFetching: false, error: null}
    },
    [DOCUMENT_UPLOAD_FAILURE]: (state, {error}) => {
        return {...state, isFetching: false, error}
    },
    [DOCUMENT_DELETE_REQUEST]: (state, action) => {
        return {...state, isFetching: true, error: null};
    },
    [DOCUMENT_DELETE_SUCCESS]: (state, {docId}) => {
        const {logo} = state;
        const documents = [...state.documents].filter(doc => doc.id !== docId);
        const l = logo && (logo.id === docId);

        return {...state, documents, isFetching: false, error: null, logo: l ? null : {...logo}}
    },
    [DOCUMENT_DELETE_FAILURE]: (state, {error}) => {
        return {...state, isFetching: false, error}
    }
};

const landlordReducer = (state = LANDLORD_INITIAL_STATE, action) => {
    let reducer = landlordReducers[action.type] || (state => state);
    return reducer(state, action);
};

export default combineReducers({
    profile: landlordReducer,
    branches: branchesReducer,
    admins: adminsReducer,
    dlo: dloReducer,
    contractors: contractorsReducer,
    properties: propertiesReducer,
    contractorSettings
});


// WEBPACK FOOTER //
// ./resources/assets/js/reducers/landlord.js